import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { CheckCircle2, Star, Download, ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-16 pb-24 lg:pt-24 lg:pb-32 overflow-hidden bg-gradient-to-b from-rose-50 to-white" data-id="element-88">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-89">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-rose-200/40 blur-3xl" data-id="element-90" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-gold-200/30 blur-3xl" data-id="element-91" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-93">
          {/* Text Content */}
          <motion.div className="max-w-2xl" initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-94">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-rose-100 text-rose-700 text-sm font-bold mb-6 tracking-wide" data-id="element-95">
              <Star className="w-4 h-4 mr-2 fill-rose-500" data-id="element-96" />
              EBOOK DIGITAL · DESCARGA INMEDIATA
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-balance" data-id="element-97">
              Aprendé Manicura Profesional y Empezá a Generar{' '}
              <span className="text-rose-500 italic" data-id="element-98">
                Ingresos Desde Tu Casa
              </span>
            </h1>

            <p className="text-lg md:text-xl text-dark-light mb-8 leading-relaxed" data-id="element-99">
              Todo lo que necesitás para aprender desde cero, conseguir tus
              primeras clientas y ganar dinero haciendo lo que te gusta.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-100">
              <Button size="xl" className="w-full sm:w-auto" data-id="element-101">
                ¡Quiero Empezar Ahora!
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap gap-4 text-sm font-medium text-dark-light" data-id="element-102">
              <div className="flex items-center" data-id="element-103">
                <Download className="w-4 h-4 mr-1 text-rose-500" data-id="element-104" />
                Descarga inmediata
              </div>
              <div className="flex items-center" data-id="element-105">
                <Star className="w-4 h-4 mr-1 text-gold-500 fill-gold-500" data-id="element-106" />
                +6.500 descargas
              </div>
              <div className="flex items-center" data-id="element-107">
                <ShieldCheck className="w-4 h-4 mr-1 text-rose-500" data-id="element-108" />
                Garantía 30 días
              </div>
            </div>
          </motion.div>

          {/* Product Mockup */}
          <motion.div className="relative mx-auto w-full max-w-md lg:max-w-lg" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-109">
            <div className="relative aspect-[3/4] rounded-2xl bg-gradient-to-br from-rose-400 to-rose-600 p-1 shadow-2xl shadow-rose-500/20 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-110">
              <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 mix-blend-overlay rounded-2xl" data-id="element-111"></div>
              <div className="w-full h-full bg-white rounded-xl overflow-hidden flex flex-col relative" data-id="element-112">
                {/* Ebook Cover Design */}
                <div className="h-1/2 bg-rose-50 flex items-center justify-center p-8 relative overflow-hidden" data-id="element-113">
                  <div className="absolute top-[-50px] right-[-50px] w-32 h-32 bg-gold-200 rounded-full blur-2xl opacity-60" data-id="element-114"></div>
                  <h3 className="font-playfair text-4xl font-bold text-rose-900 text-center relative z-10 leading-tight" data-id="element-115">
                    Empezá
                    <br data-id="element-116" />y Ganá
                  </h3>
                </div>
                <div className="h-1/2 bg-rose-600 p-8 text-white flex flex-col justify-between relative" data-id="element-117">
                  <div data-id="element-118">
                    <p className="font-sans text-sm uppercase tracking-widest text-rose-200 mb-2" data-id="element-119">
                      Guía Práctica
                    </p>
                    <p className="font-playfair text-xl font-medium leading-snug" data-id="element-120">
                      El método paso a paso para vivir de la manicura
                    </p>
                  </div>
                  <div className="flex justify-between items-end" data-id="element-121">
                    <div className="w-12 h-1 bg-gold-400 rounded-full" data-id="element-122"></div>
                    <Star className="w-8 h-8 text-gold-400 opacity-50" data-id="element-123" />
                  </div>
                </div>
              </div>
            </div>

            {/* Floating badge */}
            <motion.div className="absolute -bottom-6 -left-6 bg-white rounded-full p-4 shadow-xl flex items-center gap-3" animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-124">
              <div className="bg-green-100 p-2 rounded-full" data-id="element-125">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-126" />
              </div>
              <div data-id="element-127">
                <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-128">
                  Valoración
                </p>
                <div className="flex text-gold-500" data-id="element-129">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-130" />)}
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}